import React from "react";
import DashboardCard from "./DashboardCard";

const PerformanceTable = ({ rows = [] }) => {
  return (
    <DashboardCard className="p-3">
      <h2 className="mb-3 text-base font-bold text-customInk dark:text-customHeading">Performance by Bet Type</h2>
      <div className="overflow-hidden rounded-md border border-slate-200 dark:border-customBorder">
        <table className="min-w-full text-xs">
          <thead className="bg-customGray text-customPrimaryText dark:bg-customSurfaceMuted dark:text-customHeading">
            <tr>
              {["Type", "Bet Amount", "Payout", "Net Result", "Margin"].map((heading) => (
                <th key={heading} className="border-b border-r border-slate-200 px-3 py-2.5 text-left text-[11px] font-semibold last:border-r-0 dark:border-customBorder">
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.type} className={row.total ? "bg-customSlate/70 font-bold dark:bg-customSurfaceMuted" : "bg-white dark:bg-customSurface"}>
                <td className="border-r border-slate-200 px-3 py-2.5 dark:border-customBorder">{row.type}</td>
                <td className="border-r border-slate-200 px-3 py-2.5 dark:border-customBorder">{row.amount}</td>
                <td className="border-r border-slate-200 px-3 py-2.5 dark:border-customBorder">{row.payout}</td>
                <td className="border-r border-slate-200 px-3 py-2.5 dark:border-customBorder">
                  <span
                    className={`rounded px-2 py-1 text-[11px] font-bold text-white ${
                      row.negative ? "bg-customFontRed" : "bg-customVibrantGreen"
                    }`}
                  >
                    {row.result}
                  </span>
                </td>
                <td className="px-3 py-2.5">{row.margin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardCard>
  );
};

export default PerformanceTable;
